import { PageConfig, PageSize } from './models/report-page.model';
import { ReportType } from './models/report-type.enum';

export const LOCALIZATION_KEY = 'reporting-common';
export const REPORTING_API_BASE_URL = '/api/reporting/';
export const POLLING_INTERVAL = 1000;
export const MAX_SMALL_REPORT_ITEMS_COUNT = 30;
export const MAX_REPORT_PROFILES_COUNT = 50;

export const MAX_REPORT_PROFILES_COUNT_WITH_FT = 100;
export const DEFAULT_TRUNCATION_LENGTH = 5;
export const INCREASE_EXPORT_LIMIT_FT = 'increase-export-report-limit-to-100-isd-5807';
// Make sure the px height and width are both divisible by 4
export const US_PAGE_SIZE_PX_HEIGHT = 1056;
export const A4_PAGE_SIZE_PX_HEIGHT = 1124;
export const US_PAGE_SIZE_PX_WIDTH = 852;
export const A4_PAGE_SIZE_PX_WIDTH = 832;

export const US_PAGE_SIZE_PX_HEIGHT_ITINERARY = 852; // 8.5 inches (swapped from 1056)
export const A4_PAGE_SIZE_PX_HEIGHT_ITINERARY = 832; // 8.3 inches (swapped from 1124)
export const US_PAGE_SIZE_PX_WIDTH_ITINERARY = 1056; // 11 inches (swapped from 852)
export const A4_PAGE_SIZE_PX_WIDTH_ITINERARY = 1124; // 11.7 inches (swapped from 832)

export const DEFAULT_PAGE_BREAK_SIZE = 8;
export const EXPORT_SELECTED_ITEMS_LOCAL_STORAGE_KEY = 'exportSelectedItems';
export const EXPORT_SELECTED_TIME_LOCAL_STORAGE_KEY = 'exportSelectedTime';
export const EXPORT_REPORT_MODULE_NAME = 'exportReportModuleName';
export const EXPORT_REPORT_SELECTED_PROFILES = 'exportReportSelectedProfiles';
export const EXPORT_REPORT_INCLUDED_CONTACTS = 'exportReportIncludedContacts';
export const EXPORT_REPORT_ITINERARY_EVENT = 'exportReportItineraryEvent';
export const EXPORT_REPORT_ITINERARY_ACTIVITIES = 'exportReportItineraryActivities';
export const BNY_MANAGEMENT_REPORT_ZOOM = 0.8;
export const ITINERARY_REPORT_ZOOM = 0.8;
export const MAX_TEMPLATES_PER_ACCOUNT = 60;
export const PAGE_SIZES: Record<PageSize, PageConfig> = {
  ['us-letter']: {
    value: 'us-letter',
    label: 'usLetter',
    format: 'letter',
    width: US_PAGE_SIZE_PX_WIDTH,
    height: US_PAGE_SIZE_PX_HEIGHT
  },
  ['a4']: {
    value: 'a4',
    label: 'a4size',
    format: 'a4',
    width: A4_PAGE_SIZE_PX_WIDTH,
    height: A4_PAGE_SIZE_PX_HEIGHT
  },
  ['us-letter-itinerary']: {
    value: 'us-letter-itinerary',
    label: 'usLetterItinerary',
    format: 'letter',
    width: US_PAGE_SIZE_PX_WIDTH_ITINERARY,
    height: US_PAGE_SIZE_PX_HEIGHT_ITINERARY
  },
  ['a4-itinerary']: {
    value: 'a4-itinerary',
    label: 'a4sizeItinerary',
    format: 'a4',
    width: A4_PAGE_SIZE_PX_WIDTH_ITINERARY,
    height: A4_PAGE_SIZE_PX_HEIGHT_ITINERARY
  }
} as const;

export const SAMPLE_DATA_PROFILE_ID = '-1|';

export const SAMPLE_DATA_EVENT_ID = '-1';

export const SAMPLE_DATA_SECURITY_ID = -1;

export const ITINERARY_PREVIEW_ACTIVITY_LIMIT = 2;

export const ITINERARY_MAX_ACTIVITY_SELECTION_LIMIT = 50;

export const REPORT_TITLES: Partial<Record<ReportType, string>> = {
  [ReportType.Contact]: 'contactProfileReport',
  [ReportType.Institution]: 'investorProfileReport',
  [ReportType.HistoricalOwnership]: 'historicalOwnershipReport',
  [ReportType.Itinerary]: 'itineraryReport',
  [ReportType.BnyManagementReport]: 'bnyManagementReport'
};
